/**
 * 通讯器 · TA 和朋友的聊天（P2，用户 10-03「跟其他宠物的聊天」；列表与回放组件 6796 起草，见 ./PetChatList、./PetChatReplay）。
 * /communicator?channel=petchats 是全部聊天（一行一场），&thread=<编号> 是一场的回放：只读，主人在旁边看着，不能插话。
 * 换了当前宠物时，正在看的那一场不是这只的：不拿新宠物去读那一场，直接退回列表（地址里的 thread 去掉，replace）。
 * 宠物还没认出来（家庭名单还在读，null）到认出来，不算换宠物：直接打开回放的链接照常打开。
 */
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { PetChatList } from "./PetChatList";
import { PetChatReplay } from "./PetChatReplay";
import { usePetChatList, usePetChatReplay } from "./usePetChats";

export const PET_CHATS_HREF = "/communicator?channel=petchats";
export const petChatHref = (threadId: string) => `${PET_CHATS_HREF}&thread=${encodeURIComponent(threadId)}`;

export function PetChatsSection({ petId, name, threadId }: { petId: string | null; name: string | null; threadId: string | null }) {
  const navigate = useNavigate();
  // 最近一只认出来的宠物；换成了另一只，这一场就是上一只的
  const shownFor = useRef(petId);
  const switched = shownFor.current !== null && petId !== null && shownFor.current !== petId;
  useEffect(() => {
    if (petId === null) return;
    const before = shownFor.current;
    shownFor.current = petId;
    if (before !== null && before !== petId && threadId) navigate(PET_CHATS_HREF, { replace: true });
  }, [petId, threadId, navigate]);
  if (threadId && switched) return null;
  return threadId ? <Replay petId={petId} name={name} threadId={threadId} /> : <List petId={petId} name={name} onOpen={(id) => navigate(petChatHref(id))} />;
}

function List({ petId, name, onOpen }: { petId: string | null; name: string | null; onOpen: (threadId: string) => void }) {
  const { query, items } = usePetChatList(petId);
  return (
    <PetChatList
      petName={name}
      items={items}
      loading={query.isPending}
      error={query.error}
      hasMore={Boolean(query.hasNextPage)}
      loadingMore={query.isFetchingNextPage}
      onOpen={onOpen}
      onMore={() => void query.fetchNextPage()}
      onRetry={() => void query.refetch()}
    />
  );
}

function Replay({ petId, name, threadId }: { petId: string | null; name: string | null; threadId: string }) {
  const replay = usePetChatReplay(petId, threadId);
  return <PetChatReplay petName={name} replay={replay.data} loading={replay.isPending} error={replay.error} onRetry={() => void replay.refetch()} />;
}
